<h2 mat-dialog-title>{{ isNew ? "New Column" : "Edit Column" }}</h2>
<div mat-dialog-content>
  <div class="row">
    <div class="col-md-3"><mat-form-field class="full-width"><mat-label>Column name</mat-label><input matInput [(ngModel)]="result.columnName" name="cn" /></mat-form-field></div>
    <div class="col-md-3"><mat-form-field class="full-width"><mat-label>Output name</mat-label><input matInput [(ngModel)]="result.outputName" name="con" /></mat-form-field></div>
    <div class="col-md-3"><mat-form-field class="full-width"><mat-label>Source type</mat-label><input matInput [(ngModel)]="result.sourceType" name="cst" /></mat-form-field></div>
    <div class="col-md-3"><mat-form-field class="full-width"><mat-label>Warehouse type (blank = unsupported)</mat-label><input matInput [(ngModel)]="result.warehouseType" name="cwt" placeholder="e.g. bigint, varchar(200)" /></mat-form-field></div>
  </div>
  <div class="row">
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Display name</mat-label><input matInput [(ngModel)]="result.displayName" name="cdn" /></mat-form-field></div>
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Description</mat-label><input matInput [(ngModel)]="result.description" name="cd" /></mat-form-field></div>
    <div class="col-md-4"><mat-form-field class="full-width"><mat-label>Field group</mat-label>
      <mat-select [(value)]="result.admFieldGroupId">
        <mat-option [value]="null">(ungrouped)</mat-option>
        <mat-option *ngFor="let g of data.fieldGroups" [value]="g.admFieldGroupId">{{ g.name }}</mat-option>
      </mat-select></mat-form-field></div>
  </div>
  <div>
    <mat-checkbox [(ngModel)]="result.selectable" name="csel">Selectable</mat-checkbox>&nbsp;&nbsp;
    <mat-checkbox [(ngModel)]="result.alwaysKeep" name="cak">Always keep (primary / join key)</mat-checkbox>&nbsp;&nbsp;
    <mat-checkbox [(ngModel)]="result.isSensitive" name="csen">Sensitive</mat-checkbox>&nbsp;&nbsp;
    <mat-checkbox [(ngModel)]="result.isHighCardinality" name="chc">High cardinality</mat-checkbox>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSave()">Save column</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>&nbsp;
  <button mat-raised-button class="piButton" *ngIf="!isNew" (click)="onToggleRetired()">{{ result.retired ? "Restore" : "Retire" }}</button>
</div>
